module.exports = __webpack_public_path__ + "img/sport_americanfootball.88897ecf.png";